import { render, staticRenderFns } from "./comp-retorno-consultor.vue?vue&type=template&id=0f8acf72&scoped=true"
import script from "./comp-retorno-consultor.vue?vue&type=script&lang=js"
export * from "./comp-retorno-consultor.vue?vue&type=script&lang=js"
import style0 from "./comp-retorno-consultor.vue?vue&type=style&index=0&id=0f8acf72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8acf72",
  null
  
)

export default component.exports